import React, { createElement } from 'react';
import ErrorComponent from '../errorComponent';
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return createElement(ErrorComponent, null);
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
